import { useEffect, useRef } from 'react'
import consumer from '../../../channels/consumer'

export function useKitchenChannel({ accountId, onOrdersChanged }) {
  const subscriptionRef = useRef(null)
  const callbackRef = useRef(onOrdersChanged)
  callbackRef.current = onOrdersChanged

  useEffect(() => {
    if (!accountId) return

    subscriptionRef.current = consumer.subscriptions.create(
      { channel: 'KitchenOrdersChannel', account_id: accountId },
      { received: () => callbackRef.current() }
    )

    return () => {
      subscriptionRef.current?.unsubscribe()
      subscriptionRef.current = null
    }
  }, [accountId])
}
